import { Grid, Skeleton } from "@mui/material";
import React, { FC } from "react";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";
import { MessageIconCover } from "../UIElements/svgIcons";
import { JobIdDetailsProps } from "../../interface/job_board";

const JobInfo: FC<{ jobDetails: JobIdDetailsProps; loading: boolean }> = ({
  jobDetails,
  loading,
}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");

  return (
    <Grid container>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!loading ? (
          <InfoBox
            title={"Total Applications"}
            value={jobDetails?.stats?.number_of_applicants}
            icon={<MessageIconCover />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!loading ? (
          <InfoBox
            title={"Pending Reviews"}
            value={jobDetails?.stats?.pending_reviews}
            icon={<MessageIconCover />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>{" "}
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!loading ? (
          <InfoBox
            title={"Shortlisted Candidates"}
            value={jobDetails?.stats?.shorlisted_candidates}
            icon={<MessageIconCover />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>{" "}
      <Grid
        item
        xs={isSmall ? 12 : isMedium ? 6 : 3}
        sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
      >
        {!loading ? (
          <InfoBox
            title={"Upcoming Interviews"}
            value={jobDetails?.stats?.upcoming_interviews}
            icon={<MessageIconCover />}
          />
        ) : (
          <Skeleton variant="rounded" width={"100%"} height={100} />
        )}
      </Grid>
    </Grid>
  );
};

export default JobInfo;
